export default __webpack_public_path__ + "static/zmascarenhas-0aa452004009c4bcd51225f3d339faf5.jpg";